var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLibrary)?_c('h1',[_vm._v("Library")]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }